export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_06.dc2478af.jpg";